import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-popup-zone',
  templateUrl: './popup-zone.component.html',
  styleUrls: ['./popup-zone.component.scss']
})
export class PopupZoneComponent implements OnInit {
  @Input() stats: any = {};

  constructor() { }

  ngOnInit() {
  }

}
